'use client'

import {useEffect, useState} from 'react'

export const useCountdown = (initial: number): number => {
  const [remaining, setRemaining] = useState(initial)

  useEffect(() => {
    if (remaining <= 0) return

    const id = setInterval(() => {
      setRemaining(r => (r > 0 ? r - 1 : 0))
    }, 1000)

    return () => clearInterval(id)
  }, [])

  return remaining
}

